import { TIMELINE } from '@/mocks/entertainment';
import SectionHeading from './SectionHeading';

const TONE: Record<string, { dot: string; text: string; chip: string; label: string }> = {
  hot: { dot: 'bg-primary-500', text: 'text-primary-700', chip: 'bg-primary-100', label: '引爆' },
  green: { dot: 'bg-accent-500', text: 'text-accent-700', chip: 'bg-accent-100', label: '上新' },
  calm: { dot: 'bg-secondary-500', text: 'text-secondary-900', chip: 'bg-secondary-100', label: '口碑' },
};

export default function TimelineSection() {
  return (
    <section id="timeline" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <SectionHeading
              eyebrow="圈内大事记"
              title="这些日子，圈里都发生了什么"
              desc="把值得记住的时间点串成一条线，翻一翻就能快速复盘这一年的高光与话题。"
            />
            <div className="mt-6 flex flex-col gap-3 rounded-3xl border border-background-200/70 bg-background-50 p-5 md:p-6">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 text-background-50">
                  <i className="ri-history-line"></i>
                </span>
                <div>
                  <p className="font-heading text-lg font-bold text-foreground-950">半年度复盘</p>
                  <p className="text-xs text-foreground-500">2024.01 — 2024.09</p>
                </div>
              </div>
              <p className="text-sm leading-relaxed text-foreground-600">
                从开年的大热综艺，到夏天陆续官宣的新专辑与新片，上半年圈内话题密度不低。点开右侧时间轴，快速定位每次大事件的关键节点。
              </p>
              <a
                href="#feed"
                className="mt-1 inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
              >
                去聊最新热瓜 <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <ol className="relative ml-3 border-l border-background-200">
              {TIMELINE.map((n) => {
                const t = TONE[n.tone];
                return (
                  <li key={`${n.year}-${n.month}-${n.title}`} className="relative pb-9 pl-8 last:pb-0">
                    <span
                      className={`absolute -left-[7px] top-1 h-3.5 w-3.5 rounded-full ring-4 ring-background-100 ${t.dot}`}
                    ></span>
                    <div className="flex items-center gap-2">
                      <span className="rounded-full bg-background-50 px-2.5 py-1 font-label text-xs text-foreground-600">
                        {n.year}.{n.month}
                      </span>
                      <span className={`rounded-full px-2 py-0.5 font-label text-[11px] font-medium ${t.chip} ${t.text}`}>
                        {t.label}
                      </span>
                    </div>
                    <h3 className="mt-2.5 font-heading text-base font-bold text-foreground-950 md:text-lg">
                      {n.title}
                    </h3>
                    <p className="mt-1.5 max-w-xl text-sm leading-relaxed text-foreground-600">
                      {n.desc}
                    </p>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}